import { SolutionCard } from 'components/SolutionCard/SolutionCard';
import variant1 from 'images/icons/headerIcons/variant1.svg';
import folder from 'images/icons/folder.svg';
import agricultureIcon from 'images/icons/agricultureIcon.svg';
import plants from 'images/icons/plants.svg';
import './styles.scss';
import GradientText from 'components/GradientText';

const Solutions = () => (
    <section id="information-wrapper" className="container">
        <div className="solutions">
            <GradientText size="super-small" textColor="white">
                We offer solutions that can respond <em>to future climate change</em> and related challenges.
            </GradientText>
            <div>
                <SolutionCard
                    image={variant1}
                    numbers="22+"
                    description="years in agricultural industry"
                    position="first"
                />
                <SolutionCard
                    image={folder}
                    numbers=">150"
                    description="conducted research with our products"
                    position="second"
                />
                <SolutionCard
                    image={agricultureIcon}
                    numbers="15"
                    description="partners in various countries"
                    position="third"
                />
                <SolutionCard
                    image={plants}
                    numbers="95%"
                    description="increase yields with our solutions"
                    position="fourth"
                />
            </div>
        </div>
    </section>
);

export default Solutions;
